<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de Proyección de Cartera</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportar" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select name="bodega" id="bodega" v-model="form.bodega_id">
                  <option value="">Todas</option>
                  <option
                    v-for="bodega in bodegas"
                    :key="bodega.id"
                    :value="bodega.id"
                  >
                    {{ bodega.descripcion }}
                  </option>
                </select>
                <label for="bodega">Sucursal</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-8">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  @search="searchCliente"
                  id="cliente"
                  @input="inputClientes"
                  multiple
                  v-model="selectedClientes"
                  :options="clientes"
                  label="nombre"
                ></v-select>
                <label for="cliente">Cliente</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__content">
        <div style="max-height: 300px" class="table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Valor Total</th>
                <th>Valor de Pagos</th>
                <th>Total Pagado</th>
                <th>Saldo Total</th>
                <th>Por Vencer</th>
                <th v-for="dia in dias" :key="dia">
                  {{ dia }} días
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(proyeccion, index) in proyecciones" :key="index">
                <td>
                  <strong>{{ proyeccion.nombre }}</strong>
                </td>
                <td>
                    {{ moneyFormat(proyeccion.valor_total) }}
                </td>
                <td>
                    {{ moneyFormat(proyeccion.valor_pagos) }}
                </td>
                <td>
                    {{ moneyFormat(proyeccion.total_pagado) }}
                </td>
                <td>
                    <strong>{{ moneyFormat(proyeccion.saldo_total) }}</strong>
                </td>
                <td>
                    {{ moneyFormat(proyeccion.por_vencer) }}
                </td>
                <td v-for="dia in dias" :key="dia">
                  {{ moneyFormat(proyeccion['a_' + dia]) }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th scope="row">
                  Totales
                </th>
                <td>
                  <strong>{{ moneyFormat(lodash.sumBy(proyecciones, (o) => {
                      return parseFloat(o.valor_total);
                    })) }}</strong>
                </td>
                <td>
                  <strong>{{ moneyFormat(lodash.sumBy(proyecciones, (o) => {
                      return parseFloat(o.valor_pagos);
                    })) }}</strong>
                </td>
                <td>
                  <strong>{{ moneyFormat(lodash.sumBy(proyecciones, (o) => {
                      return parseFloat(o.total_pagado);
                    })) }}</strong>
                </td>
                <td>
                  <strong>{{ moneyFormat(lodash.sumBy(proyecciones, (o) => {
                      return parseFloat(o.saldo_total);
                    })) }}</strong>
                </td>
                <td>
                  <strong>{{ moneyFormat(lodash.sumBy(proyecciones, (o) => {
                    let valor = parseFloat(o.por_vencer);
                    if (isNaN(valor))
                      valor = 0;
                      return valor;
                    })) }}</strong>
                </td>
                <td v-for="dia in dias" :key="dia">
                  <strong>{{ moneyFormat(lodash.sumBy(proyecciones, (o) => {
                      return parseFloat(o['a_' + dia]);
                    })) }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      form: {
        persona_id: [],
        tipo_venta: "",
        valor_venta: 0,
        tipo_fecha: "P",
        desde: "",
        hasta: "",
        bodega_id: "",
        tipo_reporte: 'N'
      },
      selectedClientes: [],
      clientes: [],
      proyecciones: [],
      dias: [],
      round: round,
      lodash : _,
      moneyFormat: moneyFormat
    };
  },
  mounted: function () {
    this.form.hasta = moment(new Date()).format("YYYY-MM-DD");
    let desde = new Date();
    desde.setDate(desde.getDate() - 7);
    this.form.desde = moment(desde).format("YYYY-MM-DD");
  },
  methods: {
    inputClientes: function () {
        this.form.persona_id.splice(0, this.form.persona_id.length);
        for (let i = 0; i < this.selectedClientes.length; i++) {
            this.form.persona_id.push(this.selectedClientes[i].id);
        }
    },
    searchCliente: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.clientes = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/clientes?search=" + search, true);
      xmlhttp.send();
    },
    searchItems: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.productos = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/items?search=" + search, true);
      xmlhttp.send();
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    exportar: function () {
      this.form.tipo_reporte = "E";
      let urlApi = `${url}/reporte-proyeccion-cartera${this.serialize(this.form)}`;
      window.open(urlApi, "_blank");
    },
    consultar: function () {
        this.form.tipo_reporte = "N";
      axios
        .get(url + "/reporte-proyeccion-cartera", {
          params: this.form,
        })
        .then(({ data }) => {
          this.proyecciones = data.proyecciones;
          this.dias = data.dias;
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    inputProductos: function () {
      this.form.productos_id.splice(0, this.form.productos_id.length);
      for (let i = 0; i < this.selectedProductos.length; i++) {
        this.form.productos_id.push(this.selectedProductos[i].id);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteProyeccionCartera.vue